module.exports = __webpack_public_path__ + "static/media/ww2.f721735b.png";